import React, { useEffect, useState } from 'react';
import { Form } from '@unform/web';
import RichText from '../RichText';
import SelectSimple from 'src/components/Forms/SelectSimple';
import { useToast } from 'src/hooks/Toast';
import { useLoading } from 'src/hooks/LoadingHook';
import api from 'src/services/api';
import { Container, TicketCard } from '../../styles';
import { dateSimpleBRWithHour } from 'src/utils/date';
import ImageMultiGalleryInputToStatic from '../ImageMultiGalleryInputToStatic';
import CheckboxInput from '../CheckboxInput';
import { FaChevronCircleLeft, FaClock, FaFileExcel, FaFilePdf, FaUser } from 'react-icons/fa';
import DatePickerHour from '../DatePickerHour';
import { hash } from 'src/config';

const getPriorityColor = (priority) => {
    switch (priority) {
        case 'Crítica': return '#dc3545';
        case 'Alta': return '#fd7e14';
        case 'Média': return '#ffc107';
        case 'Baixa': return '#28a745';
        default: return '#6c757d';
    }
};

const OpenTicket = ({ item, reloadItems, returnToDashboard }) => {
    const { addToast } = useToast();
    const { addLoading, removeLoading } = useLoading();



    const [dataContent, setDataContent] = useState<Record<string, any>>();

    const status = dataContent?.status || '';
    const messages = dataContent?.messages || [];

    const reloadData = async (protocol: string) => {

        try {
            const dataItem = await api.get(`/get-ticket-content/${protocol}`);

            if (dataItem?.data) {
                setDataContent(dataItem?.data);
            }
        }
        catch (err) {

        }

    }

    useEffect(() => {
        if (item?._id) {
            setDataContent(item);
        }
    }, [item])


    const handleStatusChange = async (newStatus) => {
        addLoading({ title: 'Atualizando status', key: 'loading' });
        try {
            await api.post(`/change-ticket-status/${item.protocol}`, { status: newStatus?.[0] });

            addToast({ title: 'Status atualizado com sucesso', type: 'success' });
            reloadItems();
            reloadData(dataContent?.protocol);
            removeLoading('loading');
        } catch (error) {
            addToast({ title: 'Erro ao atualizar status', type: 'error' });
            removeLoading('loading');
        }
    };

    const handleDateChange = async (newDate) => {
        addLoading({ title: 'Atualizando data de entrega', key: 'loading' });
        try {
            await api.post(`/change-ticket-date/${item.protocol}`, { date_to_finish: newDate });

            addToast({ title: 'Prazo de entrega alterado com sucesso', type: 'success' });
            reloadItems();
            reloadData(dataContent?.protocol);
            removeLoading('loading');
        } catch (error) {
            addToast({ title: 'Erro ao adicionar prazo de entrega', type: 'error' });
            removeLoading('loading');
        }
    };


    const handleReply = async (data) => {
        if (!data?.description) return;

        addLoading({ title: 'Enviando mensagem...', key: 'sendMessage' });
        try {
            const res = await api.post(`/send-message-to-ticket/${item.protocol}`, {
                description: data.description,
                uploads: data?.uploads || []
            });


            reloadData(dataContent?.protocol)
            addToast({ title: 'Mensagem enviada com sucesso', type: 'success' });
        } catch (err) {
            addToast({ title: 'Erro ao enviar mensagem', type: 'error' });
        } finally {
            removeLoading('sendMessage');
        }
    };

    return (<>


        <div className='row ' style={{ width: '100%', background: '#ddd', padding: '15px 30px', justifyContent: 'center' }}>
            <button onClick={() => { returnToDashboard() }} style={{ background: '#162743', color: '#fff' }} className='button cursor gap-sm row scaleOnHover'><FaChevronCircleLeft style={{ fontSize: '18px', cursor: 'pointer' }} title="Voltar" />      <h2 style={{ color: '#fff' }}>Voltar</h2>  </button>

            <div className='column-start' style={{ padding: '10px', width: '100%', justifyContent: 'space-between' }}>
                <h2 style={{ color: '#333' }}>{item.title}</h2>
                <div className='row-to-column-start'> <p style={{ fontSize: '12px', textAlign: 'left', width: '100%' }}>Categoria: {item.category} | Prioridade: {item.priority} | Criado por: {item.client_name}</p>

                </div>
            </div>
        </div>

        <div className='full-width row-to-column' style={{ alignItems: 'flex-start', gap: '15px' }}>

            <div className='column  max-500' style={{ gap: '15px', width: '100%' }}>






                <Form className='column full-width gap-sm' style={{ padding: '30px', background: '#fff' }} onSubmit={handleReply}>
                    <h4 style={{ width: '100%', textAlign: 'left' }}>Adicionar nova mensagem</h4>
                    <RichText name="description" placeholder="Digite sua resposta..." />
                    <ImageMultiGalleryInputToStatic placeholder='Anexos' list={[{ name: 'url', title: 'Imagem' }]} name='uploads' />
                    <button className="greenButton2 button" >Enviar mensagem</button>
                </Form>
                <Form initialData={{ status: item?.status }}
                    style={{ padding: '30px', gap: '10px', background: '#fff' }}
                    className='full-width column'
                    onSubmit={(data) => { handleStatusChange(data?.status) }}>
                    <h4 style={{ width: '100%', textAlign: 'left' }}>Alterar status</h4>

                    <CheckboxInput unique
                        name="status"
                        placeholder="Status"


                        options={[
                            { label: 'Aguardando', value: 'Aguardando' },
                            { label: 'Em análise', value: 'Em análise' },
                            { label: 'Em produção', value: 'Em produção' },
                            { label: 'Encerrado', value: 'Encerrado' },
                            { label: 'Arquivado', value: 'Arquivado' },
                        ]}
                    />

                    <button className='button'>Alterar status</button>
                </Form>

                <Form initialData={{ status: item?.status }}
                    style={{ padding: '30px', gap: '10px', background: '#fff' }}
                    className='full-width column'
                    onSubmit={(data) => { handleDateChange(data?.date_to_finish) }}>
                    <h4 style={{ width: '100%', textAlign: 'left' }}>Previsão de entrega</h4>

                    <DatePickerHour
                        name="date_to_finish"
                    />

                    <button className='button'>Adicionar previsão de entrega</button>
                </Form>
            </div>

            <div className='column-start full-width gap-sm' style={{ padding: '30px', background: '#fff' }}>
                <h4>Mensagens:</h4>
                <div className='column-start full-width gap-sm' style={{ flexDirection: 'column-reverse' }}>
                    {messages.map((msg, idx) => (
                        <div
                            className='column-start full-width'
                            key={idx}
                            style={{
                                gap: '15px',
                                background: '#eee',
                                padding: '15px',
                                borderRadius: 5,
                                borderBottom: '2px rgba(0,0,0,0.05)',
                            }}
                        >
                            <p style={{ fontSize: '14px', lineHeight: '18px' }} dangerouslySetInnerHTML={{ __html: msg.description }} />

                            <small className='row-start' style={{ gap: '15px', color: '#888' }}>
                                <FaClock style={{ fontSize: '14px', color: '#162743' }} />
                                {msg.date ? dateSimpleBRWithHour(msg.date) : 'Data não informada'}
                                <FaUser style={{ fontSize: '14px', color: '#162743', marginLeft: '10px' }} />
                                {msg.client_name}
                            </small>

                            {msg?.uploads?.length > 0 ? (
                                <>
                                    <p>Anexos:</p>
                                    <div className='row flex-wrap' style={{ gap: '10px' }}>
                                        {msg?.uploads?.map((i, uploadIdx) => {
                                            const fileUrl = `https://content.encontrodigital.com.br/${i?.url}`;
                                            const fileName = i?.url || '';

                                            const isImage = fileName.endsWith('.jpeg') || fileName.endsWith('.jpg') || fileName.endsWith('.png');
                                            const isPDF = fileName.endsWith('.pdf');
                                            const isExcel = fileName.endsWith('.xls') || fileName.endsWith('.xlsx');

                                            return (
                                                <a key={uploadIdx} href={fileUrl} target="_blank" download style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textDecoration: 'none', color: '#333' }}>
                                                    {isImage && (
                                                        <img src={fileUrl} alt="Anexo" style={{ width: '50px', objectFit: 'contain' }} />
                                                    )}
                                                    {isPDF && (
                                                        <>
                                                            <FaFilePdf size={40} color="#E74C3C" />
                                                            <span style={{ fontSize: '12px' }}>PDF</span>
                                                        </>
                                                    )}
                                                    {isExcel && (
                                                        <>
                                                            <FaFileExcel size={40} color="#27AE60" />
                                                            <span style={{ fontSize: '12px' }}>Excel</span>
                                                        </>
                                                    )}
                                                </a>
                                            );
                                        })}
                                    </div>
                                </>
                            ) : null}
                        </div>
                    ))}
                </div>
            </div>

        </div>
    </>
    );
};

export default OpenTicket;